import { LeftOutlined } from "@ant-design/icons";
import { Link } from "react-router";
import React, { useState, useEffect } from "react";
import { Alert, Button, Form as AntdForm, Input, Typography } from "antd";
import { connect } from "react-redux";
import {
  forgotPassword as forgotPasswordAction,
  forgotPasswordErrorClear as forgotPasswordErrorClearAction,
  ForgotPasswordResponse,
  ForgotPasswordAction,
} from "@triare/auth-redux/dist/saga/auth/forgotPassword";
import { Error } from "@triare/auth-redux/dist/saga/common";
import { Action } from "@triare/auth-redux";
import {
  validationSignInEmailAndPassword,
  createRulesForAntd,
} from "../../../../utils/validations";
import SendSuccess from "./SendSuccess";
import { getMessageInError } from "../../../../hooks/fetch";
import Wrapper from "../Wrapper";
import Submit from "../../../Common/Form/Button/Submit";
import { RootState } from "../../../../store";
import { moduleName } from "../../../../store/auth";

import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

const { Text, Paragraph } = Typography;
const validationRules = createRulesForAntd(validationSignInEmailAndPassword);

interface ForgotPasswordProps {
  loading: boolean;
  response: ForgotPasswordResponse | null;
  error: Error;
  title?: string;
  forgotPassword: (payload: ForgotPasswordAction) => Action;
  forgotPasswordErrorClear: () => Action;
}

function ForgotPassword({
  forgotPassword,
  forgotPasswordErrorClear,
  loading,
  response,
  error,
  title,
}: ForgotPasswordProps) {
  const { t } = useTranslation();
  const [sendSuccess, setSendSuccess] = useState(false);

  const onFinish = ({ email }: { email: string }) => {
    forgotPassword({ email });
  };

  useEffect(() => {
    if (response) {
      setSendSuccess(true);
    }
  }, [response]);

  return (
    <Wrapper>
      <AntdForm className={styles.form} layout="vertical" onFinish={onFinish}>
        {sendSuccess ? (
          <SendSuccess />
        ) : (
          <>
            <Text className={styles.text} strong>
              {title || "Forgot your password?"}
              {/* Forgot your password? */}
            </Text>
            <Paragraph className={styles.secondary}>
              Please enter the email address associated with your account, and
              we&apos;ll send you a link to reset your password.
            </Paragraph>

            {error && (
              <AntdForm.Item>
                <Alert
                  type="error"
                  onClose={() => forgotPasswordErrorClear()}
                  message={getMessageInError(error)}
                  closable
                  showIcon
                />
              </AntdForm.Item>
            )}

            <AntdForm.Item
              name="email"
              label={`${t("email")}`}
              className={styles.email}
              rules={[validationRules]}
            >
              <Input size="large" placeholder="Please enter" />
            </AntdForm.Item>
            <Submit
              loading={loading}
              size="large"
              itemStyle={{ marginBottom: 14 }}
            >
              Request password reset
            </Submit>
            {!title ? (
              <AntdForm.Item>
                <Link to="/sign-in">
                  <Button
                    type="link"
                    size="large"
                    // style={{ color: "#8C8C8C" }}
                    block
                    icon={<LeftOutlined />}
                  >
                    Back to Login
                  </Button>
                </Link>
              </AntdForm.Item>
            ) : null}
          </>
        )}
      </AntdForm>
    </Wrapper>
  );
}

export default connect(
  (state: RootState) => ({
    loading: state[moduleName].forgotPassword.loading,
    response: state[moduleName].forgotPassword.response,
    error: state[moduleName].forgotPassword.error,
  }),
  {
    forgotPassword: forgotPasswordAction,
    forgotPasswordErrorClear: forgotPasswordErrorClearAction,
  },
)(ForgotPassword);
